const Colors = [
    [
        "#4f8fe6",
        "#0d2b52",
        "#23c17c",
    ],
    [
        "#4f8fe6",
        "#23c17c",
        "#0d2b52",
    ],
    [
        "#003e83",
        "#b875eb",
        "#fa9442",
    ],
    [
        "#9cb29e",
        "#fa9442",
        "#fff59e",
    ],
    [
        "#0d75ff",
        "#b875eb",
        "#9cb29e",
    ],
    [
        "#9cb29e",
        "#f2ff26",
        "#0057ba",
    ],
    [
        "#0d2b52",
        "#ff5200",
        "#a6ff47",
    ],
    [
        "#362304",
        "#ffb852",
        "#5c7287",
    ],
    [
        "#3e8740",
        "#fa3219",
        "#fca503",
    ],
    [
        "#2a4d9b",
        "#fca503",
        "#fb6119",
    ],
    [
        "#e9eae9",
        "#159ad1",
        "#adbe29",
    ],
    [
        "#681916",
        "#ffb852",
        "#7e8743",
    ],
    [
        "#ffb852",
        "#7e8743",
        "#681916",
    ],
    [
        "#a10b2b",
        "#66ab56",
        "#fb6119",
    ],

    [
        "#6c2b11",
        "#405416",
        "#d99e73",
    ],
    [
        "#acc1bc",
        "#d38e1a",
        "#3b755b",
    ],
    [
        "#c2332d",
        "#fcac0b",
        "#009452",
    ],
    [
        "#c2332d",
        "#009452",
        "#fcac0b",
    ],
    [
        "#fcac0b",
        "#009452",
        "#c2332d",
    ],
    [
        "#fcac0b",
        "#0368bd",
        "#c2332d",
    ],
    [
        "#fbf4ec",
        "#87a4bf",
        "#3b755b",

    ],
    [
        "#fefefe",
        "#ffc400",
        "#009452",
    ],
    [
        "#fbf4ec",
        "#3159ee",
        "#ff5937",
    ],
    [
        "#5d9d88",
        "#efebda",
        "#ebb43b",
    ],
    [
        "#efebda",
        "#5d9d88",
        "#ebb43b",
    ],
    [
        "#fff8e7",
        "#ff4c48",
        "#004996",
    ],
    [
        "#ffbcb3",
        "#ff4c48",
        "#567bae",
    ],
    [
        "#042050",
        "#f2f2f2",
        "#568486",
    ],
    [
        "#f2f2f2",
        "#568486",
        "#042050",
    ],
    [
        "#0b1a0b",
        "#dd7440",
        "#1bdf84",
    ],
    [
        "#aa3941",
        "#d5a630",
        "#f3f0df",
    ],
    [
        "#e2e6e8",
        "#f1594a",
        "#14a160",
    ],
    [
        "#e2e6e8",
        "#f5b50e",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
    ],
    [
        "#000000",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#14a160",
    ],
    [
        "#0b1a0b",
        "#dd7440",
        "#1bdf84",
    ],
    // [
    //     "#ffffff",
    //     "#fecc00",
    //     "#b72561",
    // ],
    [
        "#ffffff",
        "#f0292f",
        "#3e8741",
    ],
    [
        "#ffffff",
        "#fb6119",
        "#2a4d9b",
    ],
    [
        "#ffffff",
        "#f0292f",
        "#2a4d9b",
    ],
    // [
    //     "#ffffff",
    //     "#3e8741",
    //     "#172713",
    // ],
    [
        "#020202",
        "#00BB70",
        "#FFFFFF",
    ],
    [
        "#F7F4ED",
        "#FFCE49",
        "#FF5736",
    ],
    [
        "#DDDDDD",
        "#007861",
        "#FF3931",
    ],
    [
        "#DDDDDD",
        "#FF3931",
        "#007861",
    ],
    [
        "#f5f5b8",
        "#fa9442",
        "#ff616b",
    ],
    [
        "#f5f5b8",
        "#ffb852",
        "#58771e",
    ],
    [
        "#ebd999",
        "#00592e",
        "#003e83",
    ],
    // [
    //     "#ebd999",
    //     "#85b857",
    //     "#f20000",
    // ],
    [
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#ebd999",
        "#2619d1",
        "#00592e",
    ],
    [
        "#ebd999",
        "#ff8c00",
        "#00592e",
    ],
    [
        "#362304",
        "#ff0000",
        "#23c17c",
    ],

    [
        "#000000",
        "#fa2b00",
        "#40c945",
    ],
    [
        "#000831",
        "#d60036",
        "#f2ad78",
    ],
    [
        "#000831",
        "#99b333",
        "#ff7340",
    ],
    [
        "#000831",
        "#00d973",
        "#fa2b00",
    ],
    [
        "#b5d1cc",
        "#ff3319",
        "#0b542d",
    ],
    [
        "#ffcfc4",
        "#4f8fe6",
        "#fa2b00",
    ],
    [
        "#f5f5b8",
        "#96bfe6",
        "#328e13",
    ],
    [
        "#e9e3d5",
        "#0b542d",
        "#c14104",
    ],
    [
        "#e9e3d5",
        "#226e33",
        "#1c1c1a",
    ],
    [
        "#e9e3d5",
        "#226e33",
        "#823234",
    ],
]
export default Colors